import { useCurrentOrganization } from './useSwr';

export function usePublicSharingDisabled(): boolean {
  const org = useCurrentOrganization();
  return Boolean(org.data?.public_sharing_disabled);
}
